import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { AdminsAvatarsComponent } from '@core/account-ui';
import { EvaluationInsight } from '@core/evaluation-insights-types';
import { TranslatePipe } from '@core/i18n-legacy';
import {
  AiLogoComponent,
  BadgeComponent,
  ButtonComponent,
  HeadingComponent,
  IconButtonComponent,
} from '@core/user-interface-legacy';
import { uniqByKey } from '@core/utils-legacy';

@Component({
  selector: 'rt-evaluation-insights-banner',
  imports: [
    CommonModule,
    AiLogoComponent,
    BadgeComponent,
    HeadingComponent,
    TranslatePipe,
    ButtonComponent,
    IconButtonComponent,
    AdminsAvatarsComponent,
  ],
  templateUrl: './evaluation-insights-banner.component.html',
  styleUrl: './evaluation-insights-banner.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EvaluationInsightsBannerComponent {
  public evaluationInsights = input.required<EvaluationInsight[]>();

  public navigateToInsights = output<void>();
  public close = output<void>();

  protected users = computed(() => {
    const allUsers = this.evaluationInsights()
      .flatMap(insight => insight.sources)
      .flatMap(source => source.evaluation?.admin || source.evaluation?.guest)
      .filter(v => !!v);
    return uniqByKey(allUsers, 'id');
  });
  protected evaluationsCount = computed(
    () => this.evaluationInsights().flatMap(insight => insight.sources).length,
  );
}
